module.exports = __webpack_public_path__ + "img/郭建淼.34d309d2.jpg";